var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockedLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#158A73"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4494_15957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 9H13.5V8C13.5 6.62 12.38 5.5 11 5.5C9.62 5.5 8.5 6.62 8.5 8V9H8C7.45 9 7 9.45 7 10V15C7 15.55 7.45 16 8 16H14C14.55 16 15 15.55 15 15V10C15 9.45 14.55 9 14 9ZM11 13.5C10.45 13.5 10 13.05 10 12.5C10 11.95 10.45 11.5 11 11.5C11.55 11.5 12 11.95 12 12.5C12 13.05 11.55 13.5 11 13.5ZM9.5 9V8C9.5 7.17 10.17 6.5 11 6.5C11.83 6.5 12.5 7.17 12.5 8V9H9.5Z",
    fill: "#158A73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4494_15957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedLevel);
export default __webpack_public_path__ + "static/media/LockedLevel.1cfdf56a52278bfe73f45502512144d7.svg";
export { ForwardRef as ReactComponent };